module.exports = __webpack_public_path__ + "img/2-sdg-border@2x.b9892e69.png";